const normTxt = (v) => (v ?? "").toString().trim().toLowerCase();
const toAliases = (serviceName) =>
  Array.isArray(serviceName) ? serviceName : [serviceName];

function normalizeDecision(raw) {
  const d = String(raw ?? "")
    .toLowerCase()
    .replace(/[^a-z\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!d) return null;

  // Prefer explicit CrossCore decision keywords
  if (/\bstop\b/.test(d)) return "stop";
  if (/\brefer\b/.test(d)) return "referred";
  if (/\bcontinue\b/.test(d)) return "continue";

  // Handle "no decision" variations if you ever see them
  if (/\bno decision\b/.test(d) || /\bnodecision\b/.test(d))
    return "no_decision";

  return null;
}

export function getDecisionForService(response, serviceNames) {
  // console.log("getDecisionForService called with:", { serviceNames, response });
  const decisions = response?.clientResponsePayload?.orchestrationDecisions;
  if (!Array.isArray(decisions) || decisions.length === 0) return "processing";

  // console.log("getDecisionForService:", { serviceNames, decisions });
  const aliases = Array.isArray(serviceNames)
    ? serviceNames.map((s) =>
        String(s ?? "")
          .trim()
          .toLowerCase()
      )
    : serviceNames
    ? [
        String(serviceNames ?? "")
          .trim()
          .toLowerCase(),
      ]
    : [];

  // console.log("Service name aliases:", aliases);

  let chosen = null;

  // 1) Match a specific orchestration service (by decisionSource)
  if (aliases.length) {
    chosen = decisions.find((d) =>
      aliases.includes(
        String(d?.decisionSource ?? "")
          .trim()
          .toLowerCase()
      )
    );

    // If caller asked for a specific service and it doesn't exist, return null (as you had)
    if (!chosen) return null;
  }

  // 2) Fallback: latest by executionOrder (or decisionTime)
  if (!chosen) {
    chosen = [...decisions].sort(
      (a, b) => (b?.executionOrder ?? 0) - (a?.executionOrder ?? 0)
    )[0];
  }

  // Use decision FIRST (the real one). decisionText is informational.
  const raw = chosen?.decision ?? chosen?.decision ?? null;
  const normalized = normalizeDecision(raw);

  if (!normalized || normalized === "no_decision") return "processing";
  if (normalized === "continue") return "approved";
  if (normalized === "stop") return "declined";
  if (normalized === "referred") return "referred";

  return "processing";
}

export const getDecisionReasonForService = (resp, serviceName) => {
  const r = resp?.clientResponsePayload ?? resp ?? {};
  const decisionElements = r?.decisionElements || [];
  const aliases = toAliases(serviceName);

  const el = decisionElements.find((d) =>
    aliases.some((s) => normTxt(d?.serviceName) === normTxt(s))
  );

  return el?.decisionReason || null;
};
